import type { GlossaProgram } from '../parser/ast.js';

/**
 * Το ίδιο όνομα παραμέτρου δεν επιτρέπεται να εμφανίζεται δύο φορές στη
 * λίστα παραμέτρων ενός υποπρογράμματος — αλλιώς το copy-in στο
 * `Interpreter.callSubprogram` θα έσβηνε σιωπηλά την πρώτη τιμή με τη
 * δεύτερη. Βλ. `Interpreter.requireNoDuplicateParameters` για το runtime
 * αντίστοιχο (τρέχει στην εγγραφή του υποπρογράμματος, ΠΡΙΝ οποιαδήποτε
 * κλήση του). Δεν χρειάζεται να περπατήσει σώματα εντολών καθόλου — η ίδια
 * η λίστα παραμέτρων αρκεί.
 */
export interface DuplicateParameterName {
  readonly name: string;
  readonly subprogramName: string;
  readonly line: number;
  readonly column: number;
}

/**
 * Επιστρέφει την ΠΡΩΤΗ διπλή παράμετρο (με σειρά εμφάνισης των
 * υποπρογραμμάτων στον κώδικα), ή `null` αν δεν υπάρχει καμία.
 */
export function findDuplicateParameterName(program: GlossaProgram): DuplicateParameterName | null {
  for (const sub of program.subprograms) {
    const seen = new Set<string>();
    for (const param of sub.parameters) {
      if (seen.has(param)) {
        return { name: param, subprogramName: sub.name, line: sub.line, column: sub.column };
      }
      seen.add(param);
    }
  }
  return null;
}
